import { render, staticRenderFns } from "./pro-demand.vue?vue&type=template&id=22da8f90&scoped=true&"
import script from "./pro-demand.vue?vue&type=script&lang=js&"
export * from "./pro-demand.vue?vue&type=script&lang=js&"
import style0 from "./pro-demand.vue?vue&type=style&index=0&id=22da8f90&lang=scss&scoped=true&"
import style1 from "./pro-demand.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da8f90",
  null
  
)

export default component.exports